import View from '../../core/View';
import URLUtils from '../../util/URLUtils';
import ImageItem from '../../model/interactive/items/ImageItem';
import ButtonItem from '../../model/interactive/items/ButtonItem';
import ImageButtonItem from '../../model/interactive/items/ImageButtonItem';
import AudioItem from '../../model/interactive/items/AudioItem';
import VideoItem from '../../model/interactive/items/VideoItem';
import ScrollImageItem from '../../model/interactive/items/ScrollImageItem';
import GalleryItem from '../../model/interactive/items/GalleryItem';
import AnimatedImageItem from '../../model/interactive/items/AnimatedImageItem';
import WebZipItem from '../../model/interactive/items/WebZipItem';
import BrowserItem from '../../model/interactive/items/BrowserItem';
import MultiStateObjectItem from '../../model/interactive/items/MultiStateObjectItem';
import PanoramaImageItem from '../../model/interactive/items/PanoramaImageItem';
import TouchAlphaImageItem from '../../model/interactive/items/TouchAlphaImageItem';
import TouchImageSequenceItem from '../../model/interactive/items/TouchImageSequenceItem';

export default class InteractiveCatalogView extends View {

    createView(model, container) {

        this.baseUrl = model['baseUrl'];
        this.visualTemplate = model['visualTemplate'];
        this.libraryCatalog = model['libraryCatalog'];
        this.interactiveCatalog = model['interactiveCatalog'];

        this.interactiveCatalog.goToPage(0);
        this.interactiveCatalog._toolbarDisplay = false;

        this.interactiveCatalogContainer = $('<div>', {
            class: 'interactive-catalog-container'
        }).appendTo(container);

        this.render();

        $(window).resize(this.onResize.bind(this));


        $(window).keydown((e) => {
            if (e.which == 37) { // Left arrow
                if (this.isNavigationEnabled() && this.goToPrevPage())
                    this.render();
            } else if (e.which == 39) { // Right arrow
                if (this.isNavigationEnabled() && this.goToNextPage())
                    this.render();
            }
        });

        $(window).off('mousedown mouseup mousemove');

        $(window).on('mousedown', (e) => {
            e.stopPropagation();
            window.dragging = true;
            window.pageX = e.pageX;
        });

        $(window).on('mouseup', (e) => {
            e.stopPropagation();
            window.dragging = false;
            window.draggable = false;
        });

        $(window).on('mousemove', (e) => {
            e.stopPropagation();
            if (window.draggable) {
                let layerOffset = window.draggable.layer.offset();
                let left = e.pageX - layerOffset.left - window.draggable.draggingOffsetX;
                let top = e.pageY - layerOffset.top - window.draggable.draggingOffsetY;
                window.draggable.item.css('left', left);
                window.draggable.item.css('top', top);
            }
            else if (window.dragging) {
                let horizontalDistance = e.pageX - window.pageX;
                let horizontalDistanceThreshold = 120;

                if (horizontalDistance >= horizontalDistanceThreshold) {
                    window.dragging = false;
                    if (this.isNavigationEnabled() && this.goToPrevPage())
                        this.render();
                }
                if (horizontalDistance <= -horizontalDistanceThreshold) {
                    window.dragging = false;
                    if (this.isNavigationEnabled() && this.goToNextPage())
                        this.render();
                }
            }
        });

        return this.interactiveCatalogContainer;

    }

    render() {

        this.interactiveCatalogContainer.empty();
        this.renderInteractiveCatalog(this.interactiveCatalogContainer);

        if (this.libraryCatalog.showCatalogMenu) {
            let toolbar = this.renderToolbar();
            this.interactiveCatalogContainer.append(toolbar).click((e) => {
                if (!e.isDefaultPrevented()) {
                    toolbar.fadeToggle();
                    this.interactiveCatalog._toolbarDisplay = !this.interactiveCatalog._toolbarDisplay;
                }
            });
        }

        if (this.libraryCatalog.showPageSlider) {
            let pageSlider = this.renderPageSlider();
            this.interactiveCatalogContainer.append(pageSlider).click((e) => {
                if (!e.isDefaultPrevented()) {
                    pageSlider.fadeToggle();
                }
            });
        }

        this.onRendered();
    }

    onRendered() {
        // Custom Scrollbar
        $('.scrollable').each((i, elem) => {
            let itemDiv = $(elem);
            let axis = itemDiv.attr('axis');
            itemDiv.mCustomScrollbar({
                axis: axis,
                theme: 'minimal-dark'
            });
        });
        // Panorama
        $(".panorama").panorama_viewer({
            repeat: true,
            direction: "horizontal",
            animationTime: 700,
            easing: "ease-out",
            overlay: false
        });
        // ScratchPad
        $(".scratchPad").each((i, elem) => {
            let itemDiv = $(elem);
            let fg = itemDiv.attr('fg');
            itemDiv.wScratchPad({
                size: 50,           // The size of the brush/scratch.
                bg: null,           // Background (image path or hex color).
                fg: fg,             // Foreground (image path or hex color).
                realtime: false,    // Calculates percentage in realitime.
                scratchDown: null,  // Set scratchDown callback.
                scratchUp: null,    // Set scratchUp callback.
                scratchMove: null,  // Set scratcMove callback.
                cursor: 'pointer'   // Set cursor.
            });
        });
        // // Request FullScreen
        // var $requestFullscreenItems = $('.request-fullscreen');
        //
        // if ($requestFullscreenItems.length > 0)
        // {
        //     console.log("Vamos a hacer el request fullscreen..");
        //     if ($requestFullscreenItems[0].requestFullscreen) {
        //         $(document)
        //             .off('fullscreenchange')
        //             .off('fullscreenerror')
        //             .on('fullscreenchange', function(e) { console.log('fullscreenchange'); console.log(e); })
        //             .on('fullscreenerror', function(e) { console.log('fullscreenerror'); console.log(e); });
        //         $requestFullscreenItems[0].requestFullscreen();
        //     } else if ($requestFullscreenItems[0].webkitRequestFullscreen) {
        //         $(document)
        //             .off('webkitfullscreenchange')
        //             .off('webkitfullscreenerror')
        //             .on('webkitfullscreenchange', function(e) { console.log('fullscreenchange'); console.log(e); })
        //             .on('webkitfullscreenerror', function(e) { console.log('fullscreenerror'); console.log(e); });
        //         $requestFullscreenItems[0].webkitRequestFullscreen();
        //     } else if ($requestFullscreenItems[0].mozRequestFullScreen) {
        //         $(document)
        //             .off('mozfullscreenchange')
        //             .off('mozfullscreenerror')
        //             .on('mozfullscreenchange', function(e) { console.log('fullscreenchange'); console.log(e); })
        //             .on('mozfullscreenerror', function(e) { console.log('fullscreenerror'); console.log(e); });
        //         $requestFullscreenItems[0].mozRequestFullScreen();
        //     } else if ($requestFullscreenItems[0].msRequestFullscreen) {
        //         $(document)
        //             .off('msfullscreenchange')
        //             .off('msfullscreenerror')
        //             .on('msfullscreenchange', function(e) { console.log('fullscreenchange'); console.log(e); })
        //             .on('msfullscreenerror', function(e) { console.log('fullscreenerror'); console.log(e); });
        //         $requestFullscreenItems[0].msRequestFullscreen();
        //     }
        // }
    }

    onResize() {
        this.render();
    }

    goToPrevPage() {
        if (this.interactiveCatalog.navigationType.startsWith('MAGAZINE_2X1') && this.app.currentOrientation == 'HORIZONTAL') {

            let currentPageIndex = this.interactiveCatalog._currentPageIndex;
            let prevPageIndex = currentPageIndex;

            if (this.interactiveCatalog.firstPageLeft)
                prevPageIndex -= (currentPageIndex % 2 == 0) ? 2 : 3;
            else
                prevPageIndex -= (currentPageIndex % 2 == 0) ? 3 : 2;

            if (prevPageIndex < 0) prevPageIndex = 0;

            return this.interactiveCatalog.goToPage(prevPageIndex);
        }
        return this.interactiveCatalog.goToPrevPage();
    }

    goToNextPage() {
        if (this.interactiveCatalog.navigationType.startsWith('MAGAZINE_2X1') && this.app.currentOrientation == 'HORIZONTAL') {

            let currentPageIndex = this.interactiveCatalog._currentPageIndex;
            let nextPageIndex = currentPageIndex;

            if (this.interactiveCatalog.firstPageLeft)
                nextPageIndex += (currentPageIndex % 2 == 0) ? 2 : 1;
            else
                nextPageIndex += (currentPageIndex % 2 == 0) ? 1 : 2;

            if (nextPageIndex > this.interactiveCatalog.pages.length-1) nextPageIndex = this.interactiveCatalog.pages.length-1;

            return this.interactiveCatalog.goToPage(nextPageIndex);
        }
        return this.interactiveCatalog.goToNextPage();
    }

    canGoToPrevPage() {
        let currentPageIndex = this.interactiveCatalog._currentPageIndex;

        if (this.interactiveCatalog.navigationType.startsWith('MAGAZINE_2X1') && this.app.currentOrientation == 'HORIZONTAL') {

            if (this.interactiveCatalog.firstPageLeft)
                return currentPageIndex > 1;
            else
                return currentPageIndex > 0;

        }

        return currentPageIndex > 0;
    }

    canGoToNextPage() {
        let currentPageIndex = this.interactiveCatalog._currentPageIndex;
        let numPages = this.interactiveCatalog.pages.length;

        if (this.interactiveCatalog.navigationType.startsWith('MAGAZINE_2X1') && this.app.currentOrientation == 'HORIZONTAL') {

            if (this.interactiveCatalog.firstPageLeft)
                return (numPages % 2 == 0) ? currentPageIndex < numPages-2 : currentPageIndex < numPages-1;
            else
                return (numPages % 2 == 0) ? currentPageIndex < numPages-1 : currentPageIndex < numPages-2;

        }

        return currentPageIndex < numPages-1;
    }

    renderInteractiveCatalog(container) {

        let backgroundColor = this.getInteractiveCatalogBackgroundColor();

        let sizePercent = 100 * window.devicePixelRatio + '%';

        let interactiveCatalogDiv = $('<div>', {
            class: 'interactive-catalog',
            css: {
                'width': sizePercent,
                'height': sizePercent,
                'background-color': backgroundColor
            }
        }).appendTo(container);

        let currentNavigationType = this.interactiveCatalog.navigationType;
        let currentOrientation = this.app.currentOrientation;

        if (currentNavigationType.startsWith('MAGAZINE_2X1') && currentOrientation == 'HORIZONTAL') {
            this.renderDoublePage(interactiveCatalogDiv);
        } else {
            this.renderSinglePage(interactiveCatalogDiv);
        }

        this.renderNavigationButtons(interactiveCatalogDiv);

    }

    getInteractiveCatalogBackgroundColor() {
        let interactiveCatalog = this.interactiveCatalog;
        let interactiveCatalogPage = this.interactiveCatalog._currentPage;

        return (interactiveCatalogPage.backgroundColor != '') ?
            interactiveCatalogPage.backgroundColor :
            ((interactiveCatalog.backgroundColor != '') ? interactiveCatalog.backgroundColor : 'white');
    }

    renderSinglePage(container) {

        let pageContainer = $('<div>', {
            class: 'interactive-page-container interactive-page-container-single',
        }).appendTo(container);

        this.renderPage(this.interactiveCatalog._currentPage, pageContainer);

    }

    renderDoublePage(container) {

        let leftPageContainer = $('<div>', {
            class: 'interactive-page-container interactive-page-container-left',
        }).appendTo(container);

        let rightPageContainer = $('<div>', {
            class: 'interactive-page-container interactive-page-container-right',
        }).appendTo(container);

        let currentPageIndex = this.interactiveCatalog._currentPageIndex;

        if ((currentPageIndex % 2 == 0 && this.interactiveCatalog.firstPageLeft) ||
            (currentPageIndex % 2 == 1 && !this.interactiveCatalog.firstPageLeft)) {

            this.renderPage(this.interactiveCatalog.pages[currentPageIndex], leftPageContainer);

            if (currentPageIndex < this.interactiveCatalog.pages.length-1)
                this.renderPage(this.interactiveCatalog.pages[currentPageIndex+1], rightPageContainer);

        }
        else if ((currentPageIndex % 2 == 0 && !this.interactiveCatalog.firstPageLeft) ||
            (currentPageIndex % 2 == 1 && this.interactiveCatalog.firstPageLeft)) {

            this.renderPage(this.interactiveCatalog.pages[currentPageIndex], rightPageContainer);

            if (currentPageIndex > 0)
                this.renderPage(this.interactiveCatalog.pages[currentPageIndex-1], leftPageContainer);

        }

    }

    getFormat(navigationType, deviceOrientation) {
        if (navigationType == 'ONLY_HORIZONTAL')
            return 'HORIZONTAL';

        if (navigationType == 'ONLY_VERTICAL')
            return 'VERTICAL';

        if (navigationType == 'MAGAZINE_2X1_ADAPTABLE')
            return 'UNIVERSAL';

        if (navigationType == 'INDEPENDENT_ORIENTATIONS' ||
            navigationType == 'MAGAZINE_2X1_INDEPENDENT_ORIENTATIONS')
            return deviceOrientation;
    }

    renderPage(page, container) {

        let maxWidth = container.width();
        let maxHeight = container.height();
        // console.log('Max size: ' + maxWidth + ', ' + maxHeight);

        let format = this.getFormat(this.interactiveCatalog.navigationType, this.app.currentOrientation);

        let size;
        if (format == 'HORIZONTAL') size = page.horizontalSize;
        if (format == 'VERTICAL') size = page.verticalSize;
        if (format == 'UNIVERSAL') size = page.universalSize;

        let width = size.width;
        let height = size.height;
        // console.log('Size: ' + width + ', ' + height);

        let widthRatio = maxWidth / width;
        // console.log('width ratio: ' + widthRatio);
        let heightRatio = maxHeight / height;
        // console.log('height ratio: ' + heightRatio);

        this.scaleRatio = (widthRatio < heightRatio) ? widthRatio : heightRatio;
        // console.log('scale ratio: ' + this.scaleRatio);
        width = width * this.scaleRatio;
        height = height * this.scaleRatio;
        // console.log('final size: ' + width + ', ' + height);

        let pageDiv = $('<div>', {
            class: 'interactive-page interactive-page-centered',
            css: {
                'width': `${width}px`,
                'height': `${height}px`
            }
        }).appendTo(container);

        if (this.interactiveCatalog.horizontalAlignmentType == 'BORDER_LEFT_ALIGNED' ||
            (this.interactiveCatalog.horizontalAlignmentType == 'BORDER_CENTERED_ALIGNED' && container.css('float') == 'right') ||
            (this.interactiveCatalog.horizontalAlignmentType == '' && container.css('float') == 'right')) {
            pageDiv.removeClass('interactive-page-centered');
            pageDiv.addClass('interactive-page-left-aligned');
        }
        if (this.interactiveCatalog.horizontalAlignmentType == 'BORDER_RIGHT_ALIGNED' ||
            (this.interactiveCatalog.horizontalAlignmentType == 'BORDER_CENTERED_ALIGNED' && container.css('float') == 'left') ||
            (this.interactiveCatalog.horizontalAlignmentType == '' && container.css('float') == 'left')) {
            pageDiv.removeClass('interactive-page-centered');
            pageDiv.addClass('interactive-page-right-aligned');
        }

        // Render layers
        let layers;
        if (format == 'HORIZONTAL') layers = page.horizontalLayers;
        if (format == 'VERTICAL') layers = page.verticalLayers;
        if (format == 'UNIVERSAL') layers = page.universalLayers;

        layers.forEach((layer) => {
            this.renderLayer(layer, pageDiv).appendTo(pageDiv);
        });

    }

    renderLayer(layer, pageDiv) {

        let layerDiv = $('<div>', {
            css: {
                'width': '100%,',
                'height': '100%'
            }
        });

        let filteredItems = layer.items.filter((elem, i, array) => {
            return elem.deviceTypes.length == 0 ||
                elem.deviceTypes.some((e) => {
                    return e == "ALL" || e == "WEB";
                });
        });

        filteredItems.forEach((item) => {
            this.renderItem(item, layerDiv).appendTo(layerDiv);
        });

        return layerDiv;

    }

    renderItem(item, layerDiv) {

        let itemDiv = $('<div>', {
            id: item.itemId,
            css: {
                'width': `${this.scaleRatio * item.width}px`,
                'height': `${this.scaleRatio * item.height}px`,
                'position': 'absolute',
                'left': `${this.scaleRatio * item.left}px`,
                'top': `${this.scaleRatio * item.top}px`,
                'display': (item.hidden) ? 'none' : ''
            }
        });

        // Clonable
        if (item.clonable) {
            itemDiv.css('cursor', 'copy');

            itemDiv.on('click', (e) => {
                e.preventDefault();
                let newItem = item.clone();
                newItem.itemId = newItem.itemId + ' ' + Date.now();
                newItem.clonable = false;
                newItem.left = ((layerDiv.width()-itemDiv.width())/2)/this.scaleRatio;
                newItem.top = ((layerDiv.height()-itemDiv.height())/2)/this.scaleRatio;
                this.renderItem(newItem, layerDiv).appendTo(layerDiv);
            });
        }
        // Draggable (solo si no es clonable)
        else if (item.draggable) {
            itemDiv.css('cursor', 'move');
            itemDiv.on('click', (e) => { e.preventDefault(); });
            itemDiv.on('mousedown', (e) => {
                window.draggable = {
                    layer: layerDiv,
                    item: itemDiv,
                    draggingOffsetX: e.offsetX,
                    draggingOffsetY: e.offsetY
                };
            });
        }

        if (item.itemId != 0)
            this.interactiveCatalog._items[item.itemId] = itemDiv;

        if (item instanceof ImageItem) {
            itemDiv.css({
                'background-image': `url(${URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path)})`,
                'background-size': `${this.scaleRatio * item.width}px ${this.scaleRatio * item.height}px`
            });
        }

        if (item instanceof ButtonItem) {
            if (!itemDiv.css('cursor')) itemDiv.css('cursor', 'pointer');
            if (item.actions.length == 0 && !item.draggable && !item.clonable) {
                itemDiv.css('pointer-events', 'none');
            }
            itemDiv.click((e) => {
                if (item.actions.length > 0) e.preventDefault();
                for (let itemAction of item.actions) {
                    let interactiveCatalogController = this.app.getController("InteractiveCatalogController");
                    interactiveCatalogController.doAction(itemAction);
                }
            });
        }

        if (item instanceof ImageButtonItem) {
            if (!itemDiv.css('cursor')) itemDiv.css('cursor', 'pointer');
            itemDiv.css({
                'background-image': `url(${URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.normalPath)})`,
                'background-size': `${this.scaleRatio * item.width}px ${this.scaleRatio * item.height}px`
            });
            if (item.actions.length == 0 && !item.draggable && !item.clonable) {
                itemDiv.css('pointer-events', 'none');
            }
            itemDiv.click((e) => {
                if (item.actions.length > 0) e.preventDefault();
                for (let itemAction of item.actions) {
                    let interactiveCatalogController = this.app.getController("InteractiveCatalogController");
                    interactiveCatalogController.doAction(itemAction);
                }
            });
        }

        if (item instanceof AudioItem) {
            let audio = $('<audio>', {
                'src': URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path),
                'loop': item.loop,
                'autoPlay': item.autoPlay
            });
            itemDiv.append(audio);
        }

        if (item instanceof VideoItem) {

            itemDiv.on('click', (e) => { e.preventDefault(); });

            let video = $('<video>', {
                'src': URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path),
                'loop': item.loop,
                'autoPlay': item.autoPlay,
                'controls': false,
                css: {
                    'width': '100%',
                    'height': '100%'
                }
            }).bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', () => {
                var isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
                if (isFullscreen)
                    $(window).off("resize");
                else
                    $(window).resize(this.onResize.bind(this));
            });

            if (item.controlsStyle != 'NONE') {
                video.click((e) => {
                    console.log(video);
                    video[0].controls = !video[0].controls;
                    console.log(video);
                });
            }

            itemDiv.append(video);

            if (item.hidden) {

                let btnCloseVideo = $('<div>', {
                    css: {
                        'display': 'none',
                        'margin': '2px',
                        'padding-left': '2px',
                        'width': '18px',
                        'height': '18px',
                        'position': 'absolute',
                        'top': '0',
                        'right': '0',
                        'cursor': 'pointer',
                        'border-radius': '10px',
                        'background': this.visualTemplate.toolbarBackgroundColor,
                        'color': this.visualTemplate.toolbarTintSecondaryColor
                    }
                }).on('click', () => {
                    video[0].pause();
                    video[0].currentTime = 0;
                    itemDiv.hide();
                });

                $('<span>', {
                    class: 'glyphicon glyphicon-remove',
                    'aria-hidden': 'true'
                }).appendTo(btnCloseVideo);

                itemDiv.append(btnCloseVideo);
                itemDiv.hover(() => {
                    btnCloseVideo.stop().fadeIn();
                },() => {
                    btnCloseVideo.stop().fadeOut();
                });
            }

            if (item.fullScreen) {
                video.addClass('request-fullscreen');
            }

        }

        if (item instanceof ScrollImageItem) {

            let axisX = item.width < item.contentWidth;
            let axisY = item.height < item.contentHeight;
            let axis = ((axisY) ? 'y' : '') + ((axisX) ? 'x' : '');
            itemDiv.attr('axis', axis);
            itemDiv.addClass('scrollable');
            itemDiv.css({
                'overflow': 'auto'
            });

            $('<div>', {
                css: {
                    'width': `${this.scaleRatio * item.contentWidth}px`,
                    'height': `${this.scaleRatio * item.contentHeight}px`,
                    'background-image': `url(${URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path)})`,
                    'background-size': `${this.scaleRatio * item.contentWidth}px ${this.scaleRatio * item.contentHeight}px`
                }
            }).appendTo(itemDiv);
        }

        if (item instanceof GalleryItem) {

            for (let path of item.paths) {
                $('<img>', {
                    width: this.scaleRatio * item.width,
                    height: this.scaleRatio * item.height,
                    src: `${URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + path)}`
                }).appendTo(itemDiv);
            }

            itemDiv.css('z-index', '0'); // Evitar que la galería tape otras cosas..

            itemDiv.slidesjs({
                width: this.scaleRatio * item.width,
                height: this.scaleRatio * item.height,
                navigation: {
                    active: false
                }
            });

            if (item.hidden) {
                itemDiv.css('display', 'none');
            }
        }

        if (item instanceof AnimatedImageItem) {

            item.clear();

            for (let path of item.paths) {
                let img = $('<img>', {
                    width: this.scaleRatio * item.width,
                    height: this.scaleRatio * item.height,
                    src: `${URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + path)}`
                }).appendTo(itemDiv);

                item._images.push(img);
            }

            item.start();

        }

        if (item instanceof WebZipItem) {

            let path = item.zipPath.substring(0, item.zipPath.length-4) + '/index.html';

            let iframe = $('<iframe>', {
                scrolling: 'no',
                width: this.scaleRatio * item.width,
                height: this.scaleRatio * item.height,
                css: {
                    'border': 'none'
                },
                'src': URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + path)
            }).appendTo(itemDiv);

            iframe.on('load', function() {
                let interval = setInterval(function() {

                    if (this.contentWindow) {

                        if (this.contentWindow.document.body.clientHeight > 0) {
                            clearInterval(interval);

                            console.log("WebZipItem onLoad - scrollHeight: " + this.contentWindow.document.body.scrollHeight);

                            // Es necesario que el contenedor sea visible para obtener el tamaño con
                            // getBoundingClientRect... Si estaba oculto, mostrarlo y volver a ocultar
                            let prevVisibility = itemDiv.css('visibility');
                            let prevDisplay = itemDiv.css('display');
                            itemDiv.css('visibility', 'hidden');
                            itemDiv.css('display', '');

                            console.log("WebZipItem onLoad - scrollHeight 2: " + this.contentWindow.document.body.scrollHeight);

                            if (this.contentWindow.document.body.scrollWidth > iframe.width())
                                iframe.width(this.contentWindow.document.body.scrollWidth);
                            if (this.contentWindow.document.body.scrollHeight > iframe.height())
                                iframe.height(this.contentWindow.document.body.scrollHeight);

                            let axisX = (iframe[0].getBoundingClientRect().width - itemDiv[0].getBoundingClientRect().width) >= 1;
                            let axisY = (iframe[0].getBoundingClientRect().height - itemDiv[0].getBoundingClientRect().height) >= 1;
                            let axis = ((axisY) ? 'y' : '') + ((axisX) ? 'x' : '');
                            itemDiv.css('display', prevDisplay);
                            itemDiv.css('visibility', prevVisibility);

                            if (axis == '') {
                                itemDiv.mCustomScrollbar('destroy');
                            } else {
                                itemDiv.mCustomScrollbar({
                                    axis: axis,
                                    theme: 'minimal-dark'
                                });
                            }

                        }
                    } else {
                        clearInterval(interval);
                    }

                }.bind(this), 50);
            });

        }

        if (item instanceof BrowserItem) {

            $('<iframe>', {
                width: this.scaleRatio * item.width,
                height: this.scaleRatio * item.height,
                css: {
                    'border': 'none'
                },
                'src': item.url
            }).appendTo(itemDiv);

        }

        if (item instanceof MultiStateObjectItem) {

            itemDiv._stateObjectDivs = {};
            itemDiv._item = item;
            item.stateObjects.forEach((stateObject) => {
                let stateObjectItem = this.renderItem(stateObject.item);
                stateObjectItem.css('display', (stateObject.active) ? '' : 'none');
                itemDiv.append(stateObjectItem);
                itemDiv._stateObjectDivs[stateObject.stateName] = stateObjectItem;
                if (stateObject.active)
                    item.goToState(stateObject.stateName);
            });

        }

        if (item instanceof PanoramaImageItem) {

            itemDiv.addClass('panorama');
            itemDiv.css('display', 'none');
            itemDiv.on('click', (e) => { e.preventDefault(); });

            let img = $('<img>', {
                src: URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path),
                css: {
                    'width': `${this.scaleRatio * item.contentWidth}px`,
                    'height': `${this.scaleRatio * item.contentHeight}px`
                    //'background-image': `url(${URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path)})`,
                    //'background-size': `${this.scaleRatio * item.contentWidth}px ${this.scaleRatio * item.contentHeight}px`
                }
            }).appendTo(itemDiv);

            img.load(() => {
                setTimeout(() => {
                    itemDiv.show();
                }, 100);
            });
        }

        if (item instanceof TouchAlphaImageItem) {

            itemDiv.addClass('scratchPad');
            itemDiv.on('click', (e) => { e.preventDefault(); });
            itemDiv.on('mousedown', (e) => { e.stopPropagation(); itemDiv.css('background-color', ''); });

            let backgroundColor = this.getInteractiveCatalogBackgroundColor();
            itemDiv.css('background-color', backgroundColor);

            let fg = URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + item.path);
            itemDiv.attr('fg', fg);

        }

        if (item instanceof TouchImageSequenceItem) {

            item.clear();

            for (let path of item.paths) {
                let img = $('<img>', {
                    width: this.scaleRatio * item.width,
                    height: this.scaleRatio * item.height,
                    src: `${URLUtils.getURL(this.baseUrl + this.interactiveCatalog.catalogId + '/' + path)}`,
                    css: {
                        'display': 'none',
                        'user-drag': 'none'
                    }
                }).appendTo(itemDiv);

                item._images.push(img);
            }

            item.start();

            itemDiv.dragging = false;

            itemDiv.on('mousemove', function(e) {
                e.stopPropagation();
                if (itemDiv.dragging) {
                    let stepOffset = itemDiv.width() / item._images.length;
                    let offsetDiff = e.offsetX - itemDiv.offsetX;

                    if (offsetDiff >= stepOffset) {
                        item.goToNext();
                        itemDiv.offsetX += stepOffset;
                    }
                    if (offsetDiff <= -stepOffset) {
                        item.goToPrevious();
                        itemDiv.offsetX -= stepOffset;
                    }
                }
            });

            itemDiv.on('mouseup mouseleave', function(e) {
                e.stopPropagation();
                itemDiv.dragging = false;
            });

            itemDiv.on('mousedown', function(e) {
                e.stopPropagation();
                itemDiv.dragging = true;
                itemDiv.offsetX = e.offsetX;
            });

            itemDiv.on('click', (e) => { e.preventDefault(); });

        }

        return itemDiv;

    }

    renderToolbar() {

        let toolbarDiv = $('<div>', {
            'id': 'toolbar',
            css: {
                'display': (this.interactiveCatalog._toolbarDisplay) ? '' : 'none',
                'margin': '0px',
                'padding': '8px',
                'width': '100%',
                'height': '40px',
                'position': 'absolute',
                'left': '0',
                'top': '0',
                'background-color': this.visualTemplate.toolbarBackgroundColor//'rgba(128,128,128,0.5)'
            }
        });

        // Back button
        if (!this.libraryCatalog.useAsRoot && this.libraryCatalog.showExitButton) {
            $('<button>', {
                class: 'btn btn-xs btn-default',
                css: {
                    'background-color': `${this.visualTemplate.toolbarBackgroundColor}`,
                    'color': `${this.visualTemplate.toolbarTintSecondaryColor}`,
                    'border': '0px',
                    'font-size': '16px',
                    'font-weight': 'bold',
                    'float': 'left'
                },
                text: 'Atrás',
                click: this.onBackButtonPressed.bind(this)
            }).appendTo(toolbarDiv);
        }

        // Index
        if (this.libraryCatalog.showIndexButton) {
            if (this.interactiveCatalog.indexType == 'CATALOG_PAGE') {
                let indexBtn = $('<button>', {
                    class: 'btn btn-xs btn-default',
                    css: {
                        'background-color': `${this.visualTemplate.toolbarBackgroundColor}`,
                        'color': `${this.visualTemplate.toolbarTintSecondaryColor}`,
                        'border': '0px',
                        'float': 'right'
                    },
                    type: 'button',
                    click: (e) => {
                        e.preventDefault();
                        this.interactiveCatalog.goToPage(this.interactiveCatalog.indexNumPage);
                        this.render();
                    }
                }).appendTo(toolbarDiv);

                $('<span>', {
                    class: 'glyphicon glyphicon-th-list',
                    css: {
                        'font-size': '20px',
                        'display': 'block'
                    }
                }).appendTo(indexBtn);
            } else {
                this.createIndexDropdown(this.interactiveCatalog.indexPages, this.visualTemplate).appendTo(toolbarDiv);
            }
        }

        // Title
        let toolbarTitle = $('<h1>', {
            'text': this.interactiveCatalog._currentPage.title,
            'css': {
                'margin': '0px',
                'text-align': 'center',
                'font-size': '1.5em',
                'color': this.visualTemplate.toolbarTintColor
            }
        }).appendTo(toolbarDiv);

        return toolbarDiv;
    }

    createIndexDropdown(indexJson, visualTemplate) {

        let indexDropdown = $('<div>', {
            class: 'dropdown',
            css: {
                'float': 'right'
            }
        });

        let mainIndexList = this.createIndexList(indexJson, visualTemplate, indexDropdown);

        let indexDropdownBtn = $('<button>', {
            class: 'btn btn-xs btn-default dropdown-toggle',
            css: {
                'background-color': `${visualTemplate.toolbarBackgroundColor}`,
                'color': `${visualTemplate.toolbarTintSecondaryColor}`,
                'border': '0px'
            },
            type: 'button',
            'data-toggle': 'dropdown',
            click: function (e) {
                e.preventDefault();
                $('ul.dropdown-menu').css('display', 'none');
                mainIndexList.css('display', '');
            }
        }).appendTo(indexDropdown);

        $('<span>', {
            class: 'glyphicon glyphicon-th-list',
            css: {
                'font-size': '20px',
                'display': 'block'
            }
        }).appendTo(indexDropdownBtn);

        return indexDropdown;
    }

    createIndexList(indexJson, visualTemplate, menuDropdown) {

        let indexList = $('<ul>', {
            class: 'dropdown-menu dropdown-menu-right',
            css: {
                'max-height': '400px',
                'overflow': 'auto',
                'background-color': `${visualTemplate.toolbarBackgroundColor}`
            }
        }).appendTo(menuDropdown);

        for (let indexPage of indexJson) {

            let imgPath = this.baseUrl + this.interactiveCatalog.catalogId + '/';
            if (indexPage.horizontalIndexImage) imgPath += indexPage.horizontalIndexImage;
            else if (indexPage.verticalIndexImage) imgPath += indexPage.verticalIndexImage;

            let width = 210;
            let height = 80;

            let imgMaxWidth = 80;
            let imgMaxHeight = height;

            let img = $('<img>', { 'src': URLUtils.getURL(imgPath) });

            let imgWidthRatio = imgMaxWidth / img[0].width;
            let imgHeightRatio = imgMaxHeight / img[0].height;
            let imgScaleRatio = (imgWidthRatio < imgHeightRatio) ? imgWidthRatio : imgHeightRatio;

            img[0].width *= imgScaleRatio;
            img[0].height *= imgScaleRatio;

            img.css({
                'position': 'relative',
                'left': '50%',
                'top': '50%',
                'margin-left': `-${img[0].width/2}px`,
                'margin-top': `-${img[0].height/2}px`
            });

            let html = $('<div>', {
                'css': {
                    'width': '210px',
                    'height': '80px'
                }
            })
                .append($('<div>', {
                    'css': {
                        'float': 'left',
                        'width': imgMaxWidth+'px',
                        'height': imgMaxHeight+'px'
                    }
                })
                    .append(img)
                )
                .append($('<div>', {
                    'css': {
                        'float': 'right',
                        'width': '120px',
                        'height': '100%'
                    }
                })
                    .append($('<h4>', {
                        'text': indexPage.title
                    }))
                    .append($('<p>', {
                        'text': indexPage.description
                    }))
                );

            let onClick = (e) => {
                e.preventDefault();
                this.interactiveCatalog.goToPage(indexPage.numPage);
                this.render();
            };

            let selected = (this.interactiveCatalog._currentPageIndex == indexPage.numPage);

            this.createIndexListElement(html, visualTemplate, onClick.bind(this), selected).appendTo(indexList);
        }

        return indexList;

    }

    createIndexListElement(html, visualTemplate, onClick, selected = false) {

        let indexListElement = $('<li>', {});

        let bgColor = (selected) ? visualTemplate.toolbarTintColor : visualTemplate.toolbarBackgroundColor;
        let color = (selected) ? visualTemplate.toolbarBackgroundColor : visualTemplate.toolbarTintColor;
        let colorHover = (selected) ? visualTemplate.toolbarBackgroundColor : visualTemplate.toolbarTintSecondaryColor;

        $('<a>', {
            html: html,
            css: {
                'background-color': bgColor,
                'color': color,
                'cursor': 'pointer'
            },
            click: onClick
        }).hover(
            function() { $(this).css("color", colorHover); },
            function() { $(this).css("color", color); }
        ).appendTo(indexListElement);

        return indexListElement;

    }

    onBackButtonPressed() {
        this.app.goBack();
    }

    renderPageSlider() {

        let pageSliderDiv = $('<div>', {
            'id': 'pageSlider',
            css: {
                'display': (this.interactiveCatalog._toolbarDisplay) ? '' : 'none',
                'margin': '0px',
                'padding': '8px',
                'width': '100%',
                'height': '40px',
                'position': 'absolute',
                'left': '0',
                'bottom': '0',
                'text-align': 'center'
            }
        })
            .on('click', (e) => {e.stopPropagation();})
            .on('mousedown', (e) => {e.stopPropagation();});

        let pageSliderPreview = $('<div>', {
            'id': 'pageSlider',
            css: {
                'display': 'none',
                'margin': 'auto',
                'position': 'absolute',
                'left': '50%',
                'bottom': '0%',
                'transform': 'translate(-50%, -50%)',
            }
        }).appendTo(pageSliderDiv);

        let slider = $('<div>', {
            css: {
                'width': '90%',
                'margin': 'auto'
            }
        }).appendTo(pageSliderDiv);

        slider.slider({
            orientation: "horizontal",
            range: "min",
            max: this.interactiveCatalog.indexPages.length - 1,
            value: this.interactiveCatalog._currentPageIndex,
            slide: function(event, ui) {
                let indexPage = this.interactiveCatalog.indexPages[ui.value];

                let imgPath = this.baseUrl + this.interactiveCatalog.catalogId + '/';
                if (indexPage.horizontalIndexImage) imgPath += indexPage.horizontalIndexImage;
                else if (indexPage.verticalIndexImage) imgPath += indexPage.verticalIndexImage;

                let imgMaxSize = 120;

                let img = $('<img>', { 'src': URLUtils.getURL(imgPath) });

                let imgWidthRatio = imgMaxSize / img[0].width;
                let imgHeightRatio = imgMaxSize / img[0].height;
                let imgScaleRatio = (imgWidthRatio < imgHeightRatio) ? imgWidthRatio : imgHeightRatio;

                img[0].width *= imgScaleRatio;
                img[0].height *= imgScaleRatio;

                img.css({
                    'position': 'relative',
                    'left': '50%',
                    'top': '50%',
                    'transform': 'translate(-50%, -50%)'
                });

                pageSliderPreview.empty();
                pageSliderPreview.append(img);
                pageSliderPreview.append($('<p>', {text: indexPage.title}));
                pageSliderPreview.show();
            }.bind(this),
            change: function(event, ui) {
                this.interactiveCatalog.goToPage(ui.value);
                this.render();
            }.bind(this)
        });

        return pageSliderDiv;
    }

    renderNavigationButtons(interactiveCatalogDiv) {

        // Size of the buttons
        let navigationBtnWidth = this.scaleRatio * 80;
        let navigationBtnHeight = this.scaleRatio * 150;

        // Max size of the buttons
        navigationBtnWidth = (navigationBtnWidth > 60) ? 60: navigationBtnWidth;
        navigationBtnHeight = (navigationBtnHeight > 112) ? 112: navigationBtnHeight;

        // Is navigation enabled?
        let isNavigationEnabled = this.isNavigationEnabled();

        // Left navigation button
        if (isNavigationEnabled && this.canGoToPrevPage()) {
            $('<div>', {
                'class': 'navigation-btn navigation-btn-left',
                'css': {
                    'width': `${navigationBtnWidth}px`,
                    'height': `${navigationBtnHeight}px`
                }
            }).appendTo(interactiveCatalogDiv).on('click', (e) => {
                e.stopPropagation();
                if (this.goToPrevPage())
                    this.render();
            });
        }

        // Right navigation button
        if (isNavigationEnabled && this.canGoToNextPage()) {
            $('<div>', {
                'class': 'navigation-btn navigation-btn-right',
                'css': {
                    'width': `${navigationBtnWidth}px`,
                    'height': `${navigationBtnHeight}px`
                }
            }).appendTo(interactiveCatalogDiv).on('click', (e) => {
                e.stopPropagation();
                if (this.goToNextPage())
                    this.render();
            });
        }

    }

    isNavigationEnabled() {
        let format = this.getFormat(this.interactiveCatalog.navigationType, this.app.currentOrientation);
        let currentPage = this.interactiveCatalog._currentPage;

        // let pageHorizontalChangePageMode = (currentPage.horizontalChangePageMode != '') ? currentPage.horizontalChangePageMode : 'AUTOMATIC';
        // let pageVerticalChangePageMode = (currentPage.verticalChangePageMode != '') ? currentPage.verticalChangePageMode : 'AUTOMATIC';
        // let pageChangePageMode = (format == 'VERTICAL') ? pageVerticalChangePageMode : pageHorizontalChangePageMode;
        let pageChangePageMode = (format == 'VERTICAL') ? currentPage.verticalChangePageMode : currentPage.horizontalChangePageMode;

        // return (pageChangePageMode == 'AUTOMATIC') ? this.libraryCatalog.changePageMode != 'DISABLED' : pageChangePageMode != 'DISABLED';
        return (pageChangePageMode == '') ? this.libraryCatalog.changePageMode != 'DISABLED' : pageChangePageMode != 'DISABLED';
    }
}
